import React from 'react';

function PolicyPositionsPage() {
  return (
    <div style={{ paddingTop: '150px', padding: '0 20px' }}>
      <h1>Policy & Positions</h1>
      <p>
      </p>
    </div>
  );
}

export default PolicyPositionsPage;
